const routes = {
  login: "/id/login",
  signup: "/id/signup",
  settings: "/id/settings",
  verification: "/id/verification",
  upgrade: "/id/upgrade",
  // corporate: "/id/corporate",
  password_reset: "/id/password_reset",
};

module.exports = routes;
